import Table from '../../../components/table/table';
import { applicationData } from '../../../types/interfaces';
import { formatCurrency } from '../../../utils/Masks';
import { useEffect, useState } from 'react';
import { getProductLines } from '../../../services/ClientService';
import Span from '../../../components/texts/span/Span';
import styled from 'styled-components';

const ResponsiveTableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  
  @media (max-width: 768px) {
    -webkit-overflow-scrolling: touch;
  }
  
  /* Estilos para las tablas internas - ajustar para solo 3 columnas */
  .rdt_Table {
    width: 100%;
    min-width: 100%;
    table-layout: fixed;
    
    @media (max-width: 768px) {
      min-width: 100%;
    }
    
    @media (max-width: 480px) {
      min-width: 100%;
    }
  }
  
  .rdt_TableCol {
    width: 33.33%;
    min-width: 0;
    flex: 1;
    
    @media (max-width: 768px) {
      width: 33.33%;
      min-width: 0;
    }
    
    @media (max-width: 480px) {
      width: 33.33%;
      min-width: 0;
    }
  }
`;

interface ApplicationProps {
  applications: applicationData[];
}

const SummaryApplication: React.FC<ApplicationProps> = ({
  applications: applications,
}) => {
  const [productLines, setProductLines] = useState<any>();
  const tableData = {
    size: applications.length,
    totalElements: applications.length,
  };

  useEffect(() => {
    if (!productLines) {
      getProductLines().then((response) => {
        if (response && 'data' in response) {
          setProductLines(response.data);
        }
      });
    }
  }, [productLines]);

  const columns = [
    {
      name: 'Producto',
      selector: (row: any) => (
        <Span type='3' variant='neutral'>
          {productLines
            ? productLines.find((item: any) => item.code === row.product_line_code)
                ?.label
            : ''}
        </Span>
      ),
      grow: 1,
    },
    {
      name: 'Moneda',
      selector: (row: any) => (
        <Span type='3' variant='neutral'>
          {row.amount.currency_code}
        </Span>
      ),
      grow: 1,
    },
    {
      name: 'Monto',
      selector: (row: any) => (
        <Span type='3' variant='neutral'>
          $ {formatCurrency(row.amount.value ?? 0, true)}
        </Span>
      ),
      grow: 1.0,
      right: true,
    },
  ];

  return (
    <ResponsiveTableWrapper>
      <Table
        columns={columns}
        data={applications}
        tableData={tableData}
        variant='weak'
      />
    </ResponsiveTableWrapper>
  );
};

export default SummaryApplication;
